import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=2b31c0b0&"
import script from "./Sorter.vue?vue&type=script&lang=js&"
export * from "./Sorter.vue?vue&type=script&lang=js&"
import style0 from "./Sorter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
